import { Gear, UsersThree, Buildings, ChatsCircle } from "@phosphor-icons/react";

const BLOCKS = [
  { key: "work", title: "Work", sub: "Core tasks & workflow", icon: Gear },
  { key: "people", title: "People", sub: "Skills, motivation & expectations", icon: UsersThree },
  { key: "formalStructure", title: "Formal Structure", sub: "Design, procedures & metrics", icon: Buildings },
  { key: "informalStructure", title: "Informal Structure", sub: "Culture, norms & politics", icon: ChatsCircle },
];

export default function CongruenceBlueprint({ doc }) {
  const p = doc.payload || {};
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="congruence-blueprint">
      {BLOCKS.map((b) => (
        <div key={b.key} data-testid={`congruence-${b.key}`} className="bg-white border border-slate-200 rounded-sm overflow-hidden">
          <div className="px-5 py-3 border-b border-slate-100 flex items-center gap-2 bg-emerald-50">
            <b.icon size={18} weight="duotone" className="text-emerald-700" />
            <div>
              <h3 className="text-sm font-semibold uppercase tracking-wide text-emerald-700">{b.title}</h3>
              <p className="text-[11px] text-emerald-600/80">{b.sub}</p>
            </div>
          </div>
          <div className="p-5 min-h-[130px]"><p className="text-sm text-slate-800 whitespace-pre-wrap leading-relaxed">{p[b.key] || <span className="text-slate-300">—</span>}</p></div>
        </div>
      ))}
    </div>
  );
}
